import {
  rand,
  randAvatar,
  randBoolean,
  randEmail,
  randFullName,
  randPhoneNumber,
} from '@ngneat/falso';
import {
  IBrand,
  IPractice,
  IRole,
  IUser,
  MultifactorOverride,
} from '@principle-theorem/principle-core/interfaces';
import {
  BaseFirestoreMock,
  DocumentReference,
  MockTimestamp,
  Properties,
} from '@principle-theorem/shared';
import { PROFILE_PICS } from '../patient/patient.mock';

export class UserMock
  extends BaseFirestoreMock<Properties<Omit<IUser, 'multifactorOverride'>>>
  implements Properties<Omit<IUser, 'multifactorOverride'>>
{
  name = randFullName();
  phone = randPhoneNumber();
  email = randEmail();
  profileImageURL = randAvatar();
  multifactorOverride?: MultifactorOverride = undefined;
  roles: DocumentReference<IRole>[] = [];
  practices: DocumentReference<IPractice>[] = [];
  brands: DocumentReference<IBrand>[] = [];
  isEnabled = randBoolean();
  firstSignedInAt = MockTimestamp();
  lastSignInTime = MockTimestamp();
  lastActiveAt = MockTimestamp();
}

/**
 * Mock a user
 *
 * @export
 * @param {string} name
 * @returns {Practitioner}
 */
export function MockUser(name: string): IUser {
  const emailPrefix: string = name.toLowerCase().split(' ').join('.');
  return {
    name,
    phone: randPhoneNumber(),
    email: `${emailPrefix}@principle.dental`,
    profileImageURL: rand(PROFILE_PICS),
    roles: [],
    practices: [],
    brands: [],
    isEnabled: true,
  };
}

/**
 * Contains a list of users names
 */
export const USERS: string[] = [
  'Pierre Fauchard',
  'Edward Angle',
  'Frank Abbott',
  'William Rollins',
  'Lucy Taylor',
];
